import { Truck, Package, MapPin, Flag, Clock } from "lucide-react";
import { fmtTime } from "@/lib/api";
import { t, locale } from "@/i18n";

const Row = ({ icon: Icon, label, color = "#4accff", children, testId }) => (
  <div className="flex gap-4 py-3" data-testid={testId}>
    <div className="h-12 w-12 rounded-xl grid place-items-center shrink-0" style={{ background: `${color}1f`, color }}>
      <Icon className="h-6 w-6" />
    </div>
    <div className="min-w-0">
      <p className="nv-eyebrow">{t(label)}</p>
      <div className="text-white text-base sm:text-lg font-semibold leading-snug">{children}</div>
    </div>
  </div>
);

export const TripInfo = ({ trip, full = false }) => (
  <div className="divide-y divide-white/10">
    <Row icon={Truck} label="Mezzo da usare" testId="trip-vehicle">
      {t(trip.vehicle.type)} · {trip.vehicle.weight_t} t
      {full && <p className="text-sm text-slate-400 font-normal">{t("Altezza {h} m · Lunghezza {l} m · Targa {p}", { h: trip.vehicle.height_m, l: trip.vehicle.length_m, p: trip.vehicle.plate })}</p>}
    </Row>
    <Row icon={Package} label="Merce da caricare" color="#ffffff" testId="trip-goods">
      {t(trip.goods.description)}
      <p className="text-sm text-slate-400 font-normal">{trip.goods.packages} · {trip.goods.weight_kg.toLocaleString(locale())} kg · <b className="text-[#4accff]" data-testid="trip-ftl">{t("Carico completo (FTL)")}</b>{full && trip.goods.notes ? ` · ${t(trip.goods.notes)}` : ""}</p>
    </Row>
    <Row icon={MapPin} label="Luogo di carico" testId="trip-pickup">
      {trip.pickup.name}
      <p className="text-sm text-slate-400 font-normal">{trip.pickup.address} · {fmtTime(trip.pickup.time)}</p>
    </Row>
    <Row icon={Flag} label="Luogo di scarico" color="#ef0298" testId="trip-delivery">
      {trip.delivery.name}
      <p className="text-sm text-slate-400 font-normal">{trip.delivery.address} · {t("entro {t}", { t: fmtTime(trip.delivery.time) })}</p>
    </Row>
    <Row icon={Clock} label="Ore di viaggio" color="#f59e0b" testId="trip-hours">
      {t("{h} ore stimate · {km} km", { h: trip.estimated_hours.toLocaleString(locale()), km: trip.distance_km })}
    </Row>
  </div>
);
